import { render, staticRenderFns } from "./buy_plan.vue?vue&type=template&id=54d658f7&"
import script from "./buy_plan.js?vue&type=script&lang=js&"
export * from "./buy_plan.js?vue&type=script&lang=js&"
import style0 from "./buy_plan.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports